import type { Props, Placement as TippyPlacement } from 'tippy.js'

import { plugin as VueTippy } from 'vue-tippy'

import { definePlugin } from '/@/app'

export type Duration = Props['duration']

export type Placement = TippyPlacement
export default definePlugin(({ app }) => {
  app.use(VueTippy, {
    component: 'Tippy',
    directive: 'tippy',
    defaultProps: {
      placement: 'top',
      arrow: true,
      trigger: 'mouseenter',
      interactive: false,
      theme: 'default',
      offset: () => [0, 10],
      showOnCreate: false,
      maxWidth: 'unset',
    },
  })
})
